export default vm => {
  console.log(vm); //vue的this对象
  return {
    index: false,
    align: 'center',
    headerAlign: 'center',
    height: 'auto',
    calcHeight: 20,
    labelWidth: 130,
    header: false, // 控制操作按钮
    border: true,
    stripe: true,
    selection: true,
    editBtn: false,
    delBtn: false,
    tip: false,
    menu: true, // 表格操作栏
    column: [{
        label: '配置分类',
        align: 'left',
        prop: 'categoryName',
         overHidden: true,
      },
      {
        label: '配置名称',
        prop: 'name',
         overHidden: true,
      },
      {
        label: 'KEY',
        prop: 'code',
        overHidden: true,
      },
      {
        label: '数据类型',
        prop: 'dataType',
        formatter: vm.formatDataType,
         overHidden: true,
      },
      {
        label: '配置说明',
        prop: 'dataDescr',
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: true,
      },
      // {
      //   label: 'Value示例',
      //   prop: 'value',
      //   /** 当内容过长被隐藏时显示 tooltip */
      //   overHidden: true,
      // },
      {
        label: '创建时间',
        prop: 'addTime',
        overHidden: true,
      },
      {
        label: '更新时间',
        prop: 'updateTime',
        overHidden: true,
      }
    ]
  };
};
